"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _stylitas = require("@creditas/stylitas");

var _typography = require("@creditas-lab/typography");

var _styleUtilities = require("@creditas-lab/style-utilities");

var Container = _stylitas.styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  text-align: center;\n  margin-bottom: 8px;\n\n  ", "\n"])), _styleUtilities.media.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    margin-bottom: 0;\n  "]))));

exports.Container = Container;
Container.Value = (0, _stylitas.styled)(_typography.Typography)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: 96px;\n  line-height: 112px;\n  display: inline-block;\n  letter-spacing: 2px;\n\n  ", "\n\n  ", "\n"])), _styleUtilities.media.sm(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    font-size: 112px;\n  "]))), _styleUtilities.media.md(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    font-size: 144px;\n    line-height: 144px;\n  "]))));
Container.Exponent = (0, _stylitas.styled)(_typography.Typography)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: inline-block;\n  font-size: 22px;\n  line-height: 44px;\n  letter-spacing: 0.5px;\n\n  ", "\n"])), _styleUtilities.media.md(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    font-size: 32px;\n    line-height: 48px;\n  "]))));